import { createSlice } from '@reduxjs/toolkit';

const initialState: IAccountState = {
  api_keys: []
};

export const accountSlice = createSlice({
  name: 'inventoryaccount',
  initialState,
  reducers: {
    setApiKeys(state, {payload}) {
      return { ...state, api_keys: payload }
    },
  }
});

export const { setApiKeys } = accountSlice.actions;

export const getAccount = (state: IReducerStates) => state.account;
